import Swal from 'sweetalert2';
import { employerListUrl } from '../pages/members/Shared/Constants/AppConstant';
const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
        confirmButton: 'btn btn-primary ms-2',
        cancelButton: 'btn btn-secondary'
    },
    buttonsStyling: false
})

const SweetAlertService = {
    success: (title: any, message: any) => {
        return swalWithBootstrapButtons.fire({
            title: title,
            text: message,
            icon: 'success',
            showConfirmButton: false,
            timer: 1500,
        });
    },
    error: (title: any, message: any) => {
        return swalWithBootstrapButtons.fire({
            title: title,
            text: message,
            icon: 'error',
            confirmButtonText: 'OK'
        });
    },
    errorWithHTML: (title: any, message: any) => {
        return swalWithBootstrapButtons.fire({
            title: title,
            html: message,
            icon: 'error',
            confirmButtonText: 'OK'
        });
    },
    confirm: (title: any, message: any) => {
        return swalWithBootstrapButtons.fire({
            title: title,
            text: message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            reverseButtons: true
        });
    },
    confirmCustom: (title: any, message: any, confirmButtonText: any, cancelButtonText: any) => {
        return swalWithBootstrapButtons.fire({
            title: title,
            text: message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            reverseButtons: true
        });
    },
    info: (title: any, message: any) => {
        return swalWithBootstrapButtons.fire({
            title: title,
            text: message,
            icon: 'info',
            confirmButtonText: 'OK',
            reverseButtons: true,
            allowOutsideClick: false
        }).then((result) => {
            // If the user clicks OK, navigate to employer page
            if (result.isConfirmed) {
                window.location.href = employerListUrl;
            }
        });
    },
};

export default SweetAlertService;
